import axios from 'axios'
import logger from '../utils/log'

const base = 'https://cmsapi.mi-asahi.co.jp'
//const base = 'http://160.16.52.223:3000'
const open = base + '/api/v1/open'
const api_url = base + '/api/v1'


function refresh(params){
  let transparams = {
    token: params.token
  }
  logger.d('api', 'refresh', {
    method: "get",
    params: transparams
  })
  return axios({
    method: 'GET',
    url: `${open}/refreshToken`,
    params: transparams
  })
}
function login(params) {
  let body = {
    user: {}
  }
  if (params.hasOwnProperty('account')) {
    body.user.account = params.account
  }
  if (params.hasOwnProperty('email')) {
    body.user.email = params.email
  }
  body.user.password = params.password

  logger.d('api', 'login', {
    method: "post",
    body: body
  })
  return axios.post(`${open}/login`, body)
}

function forgotpassword(params) {
  let body = {
    email: params.email
  }
  logger.d('api', 'forgotpassword', {
    method: "post",
    body: body
  })
  return axios.post(`${open}/forgotpassword`, body)
}

function forgotpwd_valid(params) {
  let transparams = {
    token: params.token
  }
  logger.d('api', 'forgotpwd_valid', {
    method: "get",
    params: transparams
  })
  return axios({
    method: 'GET',
    url: `${open}/forgotpassword`,
    params: transparams
  })
}

function resetpassword(params) {
  let body = {
    token: params.token,
    pwdnew: params.pwd_new,
    pwdconfirm: params.pwd_confirm
  }
  logger.d('api', 'resetpassword', {
    method: "post",
    body: body
  })
  return axios.post(`${open}/resetpassword`, body)
}
function createEmployee(params) {
  let data = {
    employee: {
      eid: params.eid,
      joined_at: params.joined_at
    },
    user: {
      account: params.account,
      email: params.email,
      password: params.password
    },
    userinfo: params.userinfo
  }

  logger.d('api', 'employee', {
    method: "post",
    data: data
  })
  return axios({
    method: 'POST',
    url: `${api_url}/employee`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function deleteEmployee(params) {
  let transparams = {}
  if (params.hasOwnProperty('eid')) {
    transparams.eid = params.eid
  }
  if (params.hasOwnProperty('account')) {
    transparams.account = params.account
  }
  if (params.hasOwnProperty('email')) {
    transparams.email = params.email
  }

  logger.d('api', 'employee', {
    method: "delete",
    params: transparams
  })
  return axios({
    method: 'DELETE',
    url: `${api_url}/employee`,
    data: transparams,
    headers: {
      'x-access-token': params.token
    }
  })
}

function updateEmployee(params) {

  let data = {
    employee: {
      joined_at: params.joined_at,
      leave_at: params.leave_at
    },
    user: {
      email: params.email,
      password: params.password
    },
    userinfo: params.userinfo,
    employeeinfo: params.employeeinfo
  }
  if (params.hasOwnProperty('eid')) {
    data.eid = params.eid
  }
  if (params.hasOwnProperty('account')) {
    data.account = params.account
  }
  if (params.hasOwnProperty('email')) {
    data.email = params.email
  }
  Object.keys(data.employee).map(key => {
    if (data.employee[key] === null)
      delete data.employee[key]
  });
  Object.keys(data.user).map(key => {
    if (data.user[key] === null)
      delete data.user[key]
  });
  Object.keys(data.userinfo).map(key => {
    if (data.userinfo[key] === null)
      delete data.userinfo[key]
  });
  Object.keys(data.employeeinfo).map(key => {
    if (data.employeeinfo[key] === null)
      delete data.employeeinfo[key]
  });

  logger.d('api', 'employee', {
    method: "put",
    params: params,
    data: data
  })
  return axios({
    method: 'PUT',
    url: `${api_url}/employee`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryOneEmployee(params) {
  console.log(params);

  let transparams = {}
  if (params.hasOwnProperty('eid')) {
    transparams.eid = params.eid
  }
  if (params.hasOwnProperty('account')) {
    transparams.account = params.account
  }
  if (params.hasOwnProperty('email')) {
    transparams.email = params.email
  }

  logger.d('api', 'employee', {
    method: "get",
    params: transparams
  })
  return axios({
    method: 'GET',
    url: `${api_url}/employee`,
    params: transparams,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryAllEmployee(params) {
  let transparams = {}
  if (params.hasOwnProperty('paranoid')) {
    transparams.paranoid = params.paranoid
  }

  logger.d('api', 'employee', {
    method: "get",
    params: transparams
  })
  return axios({
    method: 'GET',
    url: `${api_url}/employee/opt/all`,
    params: transparams,
    headers: {
      'x-access-token': params.token
    }
  })
}

function setRoles(params) {
  let data = {
    eid: params.eid,
    roles: params.roles
  }

  logger.d('api', 'employee/opt/setroles', {
    method: "post",
    data: data
  })
  return axios({
    method: 'POST',
    url: `${api_url}/employee/opt/setroles`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function changePwd(params) {
  let data = {
    pwdnow: params.pwd_now,
    pwdnew: params.pwd_new,
    pwdconfirm: params.pwd_confirm
  }
  console.dir(data);
  console.log("data:" + JSON.stringify(data));
  logger.d('api', 'employee/opt/changepassword', {
    method: "post",
    data: data
  })
  return axios({
    method: 'POST',
    url: `${api_url}/employee/opt/changepassword`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function createUser(params) {
  let data = {
    user: {
      account: params.account,
      email: params.email,
      password: params.password
    },
    userinfo: params.userinfo
  }

  logger.d('api', 'user', {
    method: "post",
    data: data
  })
  return axios({
    method: 'POST',
    url: `${api_url}/user`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function deleteUser(params) {
  let transparams = {}
  if (params.hasOwnProperty('account')) {
    transparams.account = params.account
  }
  if (params.hasOwnProperty('email')) {
    transparams.email = params.email
  }

  logger.d('api', 'user', {
    method: "delete",
    params: transparams
  })
  return axios({
    method: 'DELETE',
    url: `${api_url}/user`,
    params: transparams,
    headers: {
      'x-access-token': params.token
    }
  })
}

function updateUser(params) {
  let transparams = {}
  if (params.hasOwnProperty('account')) {
    transparams.account = params.account
  }
  if (params.hasOwnProperty('email')) {
    transparams.email = params.email
  }
  let data = {
    user: {
      email: params.email,
      password: params.password
    },
    userinfo: params.userinfo
  }

  logger.d('api', 'user', {
    method: "put",
    params: transparams,
    data: data
  })
  return axios({
    method: 'PUT',
    url: `${api_url}/user`,
    params: transparams,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryOneUser(params) {
  let transparams = {}
  if (params.hasOwnProperty('account')) {
    transparams.account = params.account
  }
  if (params.hasOwnProperty('email')) {
    transparams.email = params.email
  }

  logger.d('api', 'user', {
    method: "get",
    params: transparams
  })
  return axios({
    method: 'GET',
    url: `${api_url}/user`,
    params: transparams,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryAllUser(params) {
  let transparams = {}
  if (params.hasOwnProperty('paranoid')) {
    transparams.paranoid = params.paranoid
  } else {
    transparams = null
  }

  logger.d('api', '/user/opt/query', {
    method: "get",
    params: transparams
  })
  return axios({
    method: 'GET',
    url: `${api_url}/user/opt/query`,
    params: transparams,
    headers: {
      'x-access-token': params.token
    }
  })
}

function createRole(params) {
  let data = {
    name: params.name,
    description: params.description
  }
  if (params.hasOwnProperty('level')) {
    data.level = params.level
  }
  logger.d('api', 'role', {
    method: "get",
    data: data,
  })
  return axios({
    method: 'POST',
    url: `${api_url}/role`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryRoles(params) {
  let transparams = {}
  if (params.hasOwnProperty('eid')) {
    transparams.eid = params.eid

    logger.d('api', '/employee/opt/getroles', {
      method: "get",
      params: transparams
    })
    return axios({
      method: 'GET',
      url: `${api_url}/employee/opt/getroles`,
      params: transparams,
      headers: {
        'x-access-token': params.token
      }
    })
  } else {
    logger.d('api', 'role', {
      method: "get",
      params: transparams
    })
    return axios({
      method: 'GET',
      url: `${api_url}/role`,
      params: transparams,
      headers: {
        'x-access-token': params.token
      }
    })
  }

}

function setPermissions(params) {
  let data = {
    role: params.role,
    permissions: params.permissions
  }
  logger.d('api', '/role/setpermissions', {
    method: "post",
    data: data
  })
  return axios({
    method: 'POST',
    url: `${api_url}/role/setpermissions`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function createPermission(params) {
  let data = {
    name: params.name,
    description: params.description
  }
  logger.d('api', '/permission', {
    method: "post",
    data: data
  })
  return axios({
    method: 'POST',
    url: `${api_url}/permission`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryPermissions(params) {
  let transparams = {}
  if (params.hasOwnProperty('role')) {
    transparams.role = params.role
    logger.d('api', '/role/getpermissions', {
      method: "get",
      data: data
    })
    return axios({
      method: 'GET',
      url: `${api_url}/role/getpermissions`,
      params: transparams,
      headers: {
        'x-access-token': params.token
      }
    })
  } else {
    logger.d('api', '/permission', {
      method: "get"
    })
    return axios({
      method: 'GET',
      url: `${api_url}/permission`,
      headers: {
        'x-access-token': params.token
      }
    })
  }

}

function updateTransExp(params) {
  let data = {
    eid: params.eid,
    targmonth: params.targmonth,
    datefrom: params.datefrom,
    dateto: params.dateto,
    stationfrom: params.stationfrom,
    stationto: params.stationto,
    price: params.price,
    comment: params.comment
  }
  if (params.hasOwnProperty('status')) {
    data.status = params.status
  }
  logger.d('api', '/transexp', {
    method: "put",
    data: data
  })
  return axios({
    method: 'PUT',
    url: `${api_url}/transexp`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryTransExp(params) {
  logger.d('api', '/transexp', {
    method: "get",
    params: params
  })
  return axios({
    method: 'GET',
    url: `${api_url}/transexp`,
    params: params,
    headers: {
      'x-access-token': params.token
    }
  })
}

function updateWorkingHours(params) {
  let data = {
    eid: params.eid,
    targmonth: params.targmonth,
    workinghours: params.workinghours,
    comment: params.comment
  }
  if (params.hasOwnProperty('status')) {
    data.status = params.status
  }
  logger.d('api', '/workinghours', {
    method: "put",
    data: data
  })
  return axios({
    method: 'PUT',
    url: `${api_url}/workinghours`,
    data: data,
    headers: {
      'x-access-token': params.token
    }
  })
}

function queryWorkingHours(params) {
  logger.d('api', '/workinghours', {
    method: "get",
    params: params
  })
  return axios({
    method: 'GET',
    url: `${api_url}/workinghours`,
    params: params,
    headers: {
      'x-access-token': params.token
    }
  })
}
export default {
  refresh:refresh,
  login: login,
  forgotpassword: forgotpassword,
  forgotpwdValid: forgotpwd_valid,
  resetpassword: resetpassword,
  user: {
    create: createUser,
    delete: deleteUser,
    update: updateUser,
    queryOne: queryOneUser,
    queryAll: queryAllUser
  },
  employee: {
    create: createEmployee,
    delete: deleteEmployee,
    update: updateEmployee,
    queryOne: queryOneEmployee,
    queryAll: queryAllEmployee,
    setRoles: setRoles,
    changePwd: changePwd
  },
  role: {
    create: createRole,
    query: queryRoles,
    setPermissions: setPermissions
  },
  permission: {
    create: createPermission,
    query: queryPermissions
  },
  transexp: {
    update: updateTransExp,
    query: queryTransExp
  },
  workinghours: {
    update: updateWorkingHours,
    query: queryWorkingHours
  }
}
